export const SCORE_CALCULATE_DESCRIPTION = [
  "Checking Transaction history",
  "Checking Liquidation history",
  "Checking Amounts owed and repaid",
  "Checking On Chain Credit Mix",
  "Checking Length of Credit History",
  "Checking Offchain History",
];
